import { render } from "./TracksClusterScreen.vue?vue&type=template&id=165fe145"
import script from "./TracksClusterScreen.vue?vue&type=script&lang=js"
export * from "./TracksClusterScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__